module.exports = __webpack_public_path__ + "static/media/9_CIHR.7a9aa69c.png";